
import { instantiate } from './composeApp.uninstantiated.mjs';


const exports = (await instantiate({
})).exports;

export const {
kotlinArrayGet,
kotlinArraySize,
memory,
_initialize
} = exports


